import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BASE_PATH, Configuration, DeckService } from './generated';

@Injectable({
  providedIn: 'root'
})
export class DeckHttpClient extends DeckService {
  constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
    super(httpClient, basePath, configuration);
  }

  public post<T>(...args: Parameters<typeof HttpClient.prototype.post>) {
    return this.httpClient.post<T>(...args);
  }

  public get<T>(...args: Parameters<typeof HttpClient.prototype.get>) {
    return this.httpClient.get<T>(...args);
  }

  public patch<T>(...args: Parameters<typeof HttpClient.prototype.patch>) {
    return this.httpClient.patch<T>(...args);
  }

  public put<T>(...args: Parameters<typeof HttpClient.prototype.put>) {
    return this.httpClient.put<T>(...args);
  }
}
